import React, { ReactNode, FunctionComponent, memo } from "react"
import { Link } from "react-router-dom"

interface iProps {
  children: ReactNode
  url: string
}

const LinkItem: FunctionComponent<iProps> = ({ children, url }) => {
  return (
    <Link key={url} to={url}>
      {children}
    </Link>
  )
}

export default memo(LinkItem, (prev: iProps, next: iProps) => {
  return prev.url === next.url
})
